import {BellOutlined} from "@ant-design/icons";
import {Badge} from "antd";
import React from "react";
import {useSelector} from "react-redux";

function IconButton(props) {
    const unreadCount = useSelector(state => state.Notification.unreadCount);
    const customizedTheme = useSelector(state => state.ThemeSwitcher.topbarTheme);

    return (
        <Badge count={unreadCount} overflowCount={10} {...props}>
            <BellOutlined style={{ color: customizedTheme.textColor }} />
        </Badge>
    );
}

export default IconButton;
